export function ServiceArea() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const navHeight = 80;
      const elementPosition = contactSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="bg-gradient-to-br from-[#2D5016] via-[#4A7C2C] to-[#2D5016] py-20 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Proudly Serving Owings Mills, Maryland
            </h2>
            <p className="text-lg text-white/90 mb-6 leading-relaxed">
              As a local, family-owned business, we're proud to serve homeowners and businesses throughout Owings Mills and the surrounding Maryland communities. Our deep roots in the area mean we understand the unique landscaping needs of our region, from seasonal challenges to local soil conditions.
            </p>
            <p className="text-lg text-white/90 mb-8 leading-relaxed">
              Whether you need regular lawn maintenance, a complete yard transformation, or emergency services like snow removal, we're here to help. Our commitment to the Owings Mills community drives us to deliver exceptional results on every project.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-5">
              <button 
                onClick={scrollToContact}
                className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#2D5016] transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line text-xl"></i>
                Request a Quote
              </button>
            </div>
          </div>

          <div className="relative h-[500px] rounded-3xl overflow-hidden shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d98478.64825890524!2d-76.85050268671875!3d39.41934!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c81be8534194c3%3A0x9f5f0b1b5e5f0b1b!2sOwings%20Mills%2C%20MD!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Owings Mills, Maryland service area"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
